import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { HomeHero } from "@/components/home/HomeHero";
import { HomeServices } from "@/components/home/HomeServices";
import { HomeAbout } from "@/components/home/HomeAbout";
import { HomeResources } from "@/components/home/HomeResources";
import { buildSeo } from "@/lib/seo";
const FloatingVideoPopup = lazy(() =>
  import("@/components/FloatingVideoPopup").then((m) => ({ default: m.FloatingVideoPopup })),
);

export const Route = createFileRoute("/")({
  head: () =>
    buildSeo({
      title: "SEO & Digital Marketing Specialist in Bangladesh | Tamal",
      description: "Work with Rangpur-based Freelancer Tamal on technical SEO, local search and digital marketing. Explore services or start with a free SEO audit.",
      path: "/",
      ogEyebrow: "SEO · AEO · GEO · Digital Marketing",
      image: "/og/home.jpg",
      keywords: "SEO expert Bangladesh, AEO expert Bangladesh, GEO expert Bangladesh, best digital marketing expert Bangladesh, answer engine optimization, generative engine optimization, ChatGPT SEO consultant, freelance SEO consultant Rangpur, technical SEO, local SEO, Shopify SEO, Freelancer Tamal",
      alternates: { bn: "/bn" },
    }),
  component: Home,
});


function Home() {
  return (
    <>
      {/* WebSite + SearchAction schema lives in __root.tsx and the FAQPage
          graph in <HomeResources />; don't duplicate them here. */}
      <HomeHero />
      <HomeServices />
      <HomeAbout />
      <HomeResources />
      <Suspense fallback={null}>
        <FloatingVideoPopup />
      </Suspense>
    </>
  );
}
